import PageAdmin from './pageAdmin';
export default PageAdmin;
